// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__2Lb7n","inputDescription":"styles_inputDescription__1wVUq"};